import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsProductStats.sss';

interface Props {
  className?: string,
}

export const ProductDetailsProductStatsSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <ul className={classNames(s.list, className)}>
      {Array(5).fill(null).map((_, i) => (
        <li
          key={i}
          className={s.item}
        >
          <Skeleton
            width='100%'
            height='12px'
          />
        </li>
      ))}
    </ul>
  );
};
